import { MASK_PLACEHOLDER_PREVIEW_IMG_SRC } from 'components/VisualStudioPlayground/Shapes/MaskShape/constants'
import { useId } from 'react'

export const Bookmark = () => {
  const imageId = useId()
  const patternId = useId()

  return (
    <svg width="64" viewBox="0 0 64 83" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M63.2887 82.0525L31.2381 56.9658L0.831055 82.0525V0.262451H63.2887V82.0525Z"
        fill={`url(#${patternId})`}
        fillOpacity="0.6"
      />
      <defs>
        <pattern id={patternId} patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlinkHref={`#${imageId}`} transform="matrix(0.0110972 0 0 0.0111111 0.000626541 0)" />
        </pattern>
        <image id={imageId} width="90" height="90" xlinkHref={MASK_PLACEHOLDER_PREVIEW_IMG_SRC} />
      </defs>
    </svg>
  )
}
